import { Box, Stack } from '@mui/material'
import { memo } from 'react'

import Text from '../text/Text'
import ProviderIcon from '../exchangeProviderCard/ProviderIcon'

const StatusUpgradeItem = ({ t, label, sx, subtitle, id, name, actions }) => {
  return (
    <Box
      sx={{
        color: 'var(--layout-nav-text-primary-color)',
        bgcolor: 'background.neutral',
        borderRadius: 2,
        p: 2,
        gap: 1,
        display: 'flex',
        width: 1,
        ...sx
      }}
    >
      <Stack
        direction='row'
        spacing={1}
        sx={{ flexGrow: 1, alignItems: 'center' }}
      >
        <ProviderIcon size={68} src={`/assets/tiers/${id}-s.png`} />
        <Stack spacing={0.5}>
          <Text label={t(label, { name })} color='inherit' variant='h5' />
          {subtitle}
        </Stack>
      </Stack>
      {actions}
    </Box>
  )
}

export default memo(StatusUpgradeItem)
